import React from "react";
import { useState } from "react";
import "./Events.scss";
import {Box} from "@mui/material";
import { EventsModel } from "model/screensModels/EventsModel";
import EventList from "./EventList";
import { CreateEvent } from "./CreateEvent";

export default function Events  ()  {

  const [updateValue, setUpdateValue] = React.useState(new EventsModel());
  const [flag, setFlag] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  //to get update record value
  const getUpdateRecordValue = (EventsModel: EventsModel) =>{
    setIsEditMode(true);
    setUpdateValue(EventsModel);
  }

  const addEvent = () =>{
    setUpdateValue(new EventsModel() )
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
}
  return (
    <>
     <Box sx={{ width: '100%' }} className="container container-h-full">
      <Box>

      <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Event List</h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Event' : 'Add Event'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addEvent}>Add Event</button>}
          </div>
      </Box>
     
        {!flag ?
          <div className="sub-content-sec recently-blog">
          <EventList setFlag={setFlag} updateRecord={getUpdateRecordValue}></EventList>
          </div>
        :
        <CreateEvent setFlag={setFlag} updateRecord={updateValue}></CreateEvent>
        }
        
      
    </Box>
    </>
  );
};